<template>
  <div >
    <b-container fluid class="md-content">
        <div class="md-header">Umsatz Vorlagen</div>
        <b-card>
            
            <b-row>
                <b-col>
                    <b-button variant="success" @click="showModal('modal-createstoresalestemplategroup')">Umsatz Vorlage anlegen</b-button>
                </b-col>
                <b-col>
                    <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-if="storeSalesTemplateGroups != undefined">
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="storeSalesTemplateGroups" :fields="storeSalesTemplateGroupFields">
                        <template slot="actions" slot-scope="row">
                            <b-button class="mx-1" size="sm" v-on:click="openStoreSalesTemplateGroupViewModal(row.item.id)"><i class="fas fa-eye"></i></b-button>
                            <b-button class="mx-1" size="sm" v-on:click="openStoreSalesTemplateGroupEditModal(row.item.id)"><i class="fas fa-pencil-alt"></i></b-button>
                            <b-button class="mx-1" size="sm" variant="danger" v-on:click="openStoreSalesTemplateGroupDeleteModal(row.item.id)"><i class="fas fa-trash"></i></b-button>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </b-card>
    </b-container>

    <b-modal ref="modal-viewstoresalestemplategroup"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Umsatz Vorlage Detail" @cancel="hideModal('modal-viewstoresalestemplategroup')" @ok="hideModal('modal-viewstoresalestemplategroup')" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>
                <b-tab title="Vorlage" active>
                    <div v-if="storeSalesTemplateGroupMap[storeSalesTemplateGroupId] != undefined">
                        <b-row>
                            <b-col class="md-2">
                                <b>Name:</b> 
                            </b-col>
                            <b-col>
                                <p>{{storeSalesTemplateGroupMap[storeSalesTemplateGroupId].name}}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Beschreibung:</b> 
                            </b-col>
                            <b-col>
                                <p>{{storeSalesTemplateGroupMap[storeSalesTemplateGroupId].description}}</p>
                            </b-col>
                        </b-row>
                    </div>
                </b-tab>

                <b-tab title="Umsatz Muster">
                    <b-row class="my-1">
                        <b-col>
                            <b-button variant="success" @click="showModal('modal-createstoresalestemplate')">Umsatz Muster hinzufügen</b-button>
                        </b-col>
                    </b-row>
                    <div v-if="storeSalesTemplates!= undefined">
                        <b-table striped hover :borderless="true" :outlined="false" :items="storeSalesTemplates" :fields="storeSalesTemplateFields">
                            <template slot="amount" slot-scope="row">
                                {{row.item.amount/100}}
                                
                            </template>
                            <template slot="actions" slot-scope="row">
                                <b-button class="mx-1" size="sm" v-on:click="openStoreSalesTemplateViewModal(row.item.id)"><i class="fas fa-eye"></i></b-button>
                                <b-button class="mx-1" size="sm" v-on:click="openStoreSalesTemplateEditModal(row.item.id)"><i class="fas fa-pencil-alt"></i></b-button>
                                <b-button class="mx-1" size="sm" variant="danger" v-on:click="openStoreSalesTemplateDeleteModal(row.item.id)"><i class="fas fa-trash"></i></b-button>
                            </template>
                        
                        </b-table>
                    </div>
                    
                </b-tab>
            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>

    <b-modal ref="modal-viewstoresalestemplate"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Muster Umsatz Detail" @cancel="hideModal('modal-viewstoresalestemplate')" @ok="hideModal('modal-viewstoresalestemplate')" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>
                <b-tab title="Vorlage" active>
                    <div v-if="storeSalesTemplateMap[storeSalesTemplateId] != undefined">
                        <b-row>
                            <b-col class="md-2">
                                <b>Wochentage:</b> 
                            </b-col>
                            <b-col>
                                <p >{{storeSalesTemplateMap[storeSalesTemplateId].weekDays}} </P>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Von:</b> 
                            </b-col>
                            <b-col>
                                {{storeSalesTemplateMap[storeSalesTemplateId].from}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Bis:</b> 
                            </b-col>
                            <b-col>
                                {{storeSalesTemplateMap[storeSalesTemplateId].to}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Stückzahl:</b> 
                            </b-col>
                            <b-col>
                                {{storeSalesTemplateMap[storeSalesTemplateId].itemCount}}
                            </b-col>
                             <b-col class="md-2">
                                <b>Gästezahl:</b> 
                            </b-col>
                            <b-col>
                                {{storeSalesTemplateMap[storeSalesTemplateId].guestCount}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Betrag:</b> 
                            </b-col>
                            <b-col>
                                {{storeSalesTemplateMap[storeSalesTemplateId].amount}}
                            </b-col>
                             <b-col class="md-2">
                                <b>Währung:</b> 
                            </b-col>
                            <b-col>
                                {{storeSalesTemplateMap[storeSalesTemplateId].currency}}
                            </b-col>
                        </b-row>
                        
                        <b-row>
                            <b-col class="md-2">
                                <b>Beschreibung:</b> 
                            </b-col>
                            <b-col>
                                {{storeSalesTemplateMap[storeSalesTemplateId].description}}
                            </b-col>
                        </b-row>
                    </div>
                </b-tab>
                

            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>

    <b-modal ref="modal-createstoresalestemplategroup"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Umsatz Vorlage anlegen" @cancel="hideModal('modal-createstoresalestemplategroup')" @ok="createStoreSalesTemplateGroup" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
 
                <b-form-group label-cols="4" label-cols-lg="2" label="Name" label-for="cstg1">
                    <b-form-input id="cstg1" v-model="storeSalesTemplateGroup.name" ></b-form-input>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="2" label="Beschreibung" label-for="cstg1">
                    <b-form-input id="cstg1" v-model="storeSalesTemplateGroup.description" ></b-form-input>
                </b-form-group>

            </div>
            
            <b-row v-if="error">
                Fehler beim Erstellen der Umsatz Vorlage.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-createstoresalestemplate"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Muster Umsatz anlegen" @cancel="hideModal('modal-createstoresalestemplate')" @ok="createStoreSalesTemplate" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
            
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Umsatz" label-for="css1-1" >
                    <b-form-input min="0" id="css1" v-model.number="storeSalesTemplate.amount" step="0.01" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Stückzahl" label-for="css1-2" >
                    <b-form-input min="0" id="css1-2" v-model.number="storeSalesTemplate.itemCount" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Gästezahl" label-for="css1-3" >
                    <b-form-input min="0" id="css1-3" v-model.number="storeSalesTemplate.guestCount" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Währung" label-for="css2">
                    <b-form-select id = "css2" v-model="storeSalesTemplate.currency">
                        <option v-bind:key ="1" v-bind:value="'EUR'">
                            EUR
                        </option>
                        <option v-bind:key ="2" v-bind:value="'USD'">
                            USD
                        </option>
                        <option v-bind:key ="3" v-bind:value="'GBP'">
                            GBP
                        </option>
                        <option v-bind:key ="4" v-bind:value="'CHF'">
                            CHF
                        </option>
                        <option v-bind:key ="5" v-bind:value="'CZK'">
                            CZK
                        </option>
                        <option v-bind:key ="6" v-bind:value="'JPY'">
                            JPY
                        </option>
                        <option v-bind:key ="7" v-bind:value="'CNY'">
                            CNY
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Uhrzeit von" label-for="cst2">
                    <b-form-input id="cst2" v-model="storeSalesTemplate.from" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Uhrzeit bis" label-for="cst3">
                    <b-form-input id="cst3" v-model="storeSalesTemplate.to" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Montag" label-for="mondaycheck">
                     <b-form-checkbox id="mondaycheck" v-model="storeSalesTemplate.monday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Dienstag" label-for="tuesdaycheck">
                     <b-form-checkbox id="tuesdaycheck" v-model="storeSalesTemplate.tuesday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Mittwoch" label-for="wednesdaycheck">
                     <b-form-checkbox id="wednesdaycheck" v-model="storeSalesTemplate.wednesday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Donnerstag" label-for="thursdaycheck">
                     <b-form-checkbox id="thursdaycheck" v-model="storeSalesTemplate.thursday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Freitag" label-for="fridaycheck">
                     <b-form-checkbox id="fridaycheck" v-model="storeSalesTemplate.friday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Samstag" label-for="saturdaycheck">
                     <b-form-checkbox id="saturdaycheck" v-model="storeSalesTemplate.saturday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Sonntag" label-for="sundaycheck">
                     <b-form-checkbox id="sundaycheck" v-model="storeSalesTemplate.sunday">
                    </b-form-checkbox>
                </b-form-group>

                 <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Beschreibung" label-for="cst9">
                    <b-form-input id="cst9" v-model="storeSalesTemplate.description" type="text"></b-form-input>
                </b-form-group>
            </div>
            
            <b-row v-if="error">
                Fehler beim Erstellen des Muster Umsatzes.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-editstoresalestemplategroup"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Muster Umsatz bearbeiten" @cancel="hideModal('modal-editstoresalestemplategroup')" @ok="updateStoreSalesTemplateGroup" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
                <b-form-group label-cols="4" label-cols-lg="2" label="Name" label-for="ustg1">
                    <b-form-input id="ustg1" v-model="storeSalesTemplateGroupUpdate.name" type="text"></b-form-input>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="2" label="Beschreibung" label-for="ustg2">
                    <b-form-input id="ustg2" v-model="storeSalesTemplateGroupUpdate.description" type="text"></b-form-input>
                </b-form-group>
            </div>
            
            <b-row v-if="error">
                Fehler beim Update der Umsatz Vorlage.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-editstoresalestemplate"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Muster Umsatz bearbeiten" @cancel="hideModal('modal-editstoresalestemplate')" @ok="updateStoreSalesTemplate" cancel-title="Abbrechen">
        <b-container fluid>
            <div>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Zukünftigte Umsätze aktualisieren" label-for="shiftcheck">
                    <b-form-checkbox id="shiftcheck" v-model="storeSalesTemplateUpdate.updateStoreSales">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Umsatz" label-for="css1" >
                    <b-form-input min="0" id="css1" v-model.number="storeSalesTemplateUpdate.amount" step="0.01" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Stückzahl" label-for="css1-2" >
                    <b-form-input min="0" id="css1-2" v-model.number="storeSalesTemplateUpdate.itemCount" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Gästezahl" label-for="css1-3" >
                    <b-form-input min="0" id="css1-3" v-model.number="storeSalesTemplateUpdate.guestCount" type="number"></b-form-input>
                </b-form-group>
                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Währung" label-for="css2">
                    <b-form-select id = "css2" v-model="storeSalesTemplateUpdate.currency">
                        <option v-bind:key ="1" v-bind:value="'EUR'">
                            EUR
                        </option>
                        <option v-bind:key ="2" v-bind:value="'USD'">
                            USD
                        </option>
                        <option v-bind:key ="3" v-bind:value="'GBP'">
                            GBP
                        </option>
                        <option v-bind:key ="4" v-bind:value="'CHF'">
                            CHF
                        </option>
                        <option v-bind:key ="5" v-bind:value="'CZK'">
                            CZK
                        </option>
                        <option v-bind:key ="6" v-bind:value="'JPY'">
                            JPY
                        </option>
                        <option v-bind:key ="7" v-bind:value="'CNY'">
                            CNY
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Uhrzeit von" label-for="ust2">
                    <b-form-input id="ust2" v-model="storeSalesTemplateUpdate.from" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label="Uhrzeit bis" label-for="cst3">
                    <b-form-input id="ust3" v-model="storeSalesTemplateUpdate.to" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Montag" label-for="umondaycheck">
                     <b-form-checkbox id="umondaycheck" v-model="storeSalesTemplateUpdate.monday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Dienstag" label-for="utuesdaycheck">
                     <b-form-checkbox id="utuesdaycheck" v-model="storeSalesTemplateUpdate.tuesday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Mittwoch" label-for="uwednesdaycheck">
                     <b-form-checkbox id="uwednesdaycheck" v-model="storeSalesTemplateUpdate.wednesday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Donnerstag" label-for="uthursdaycheck">
                     <b-form-checkbox id="uthursdaycheck" v-model="storeSalesTemplateUpdate.thursday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Freitag" label-for="ufridaycheck">
                     <b-form-checkbox id="ufridaycheck" v-model="storeSalesTemplateUpdate.friday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Samstag" label-for="usaturdaycheck">
                     <b-form-checkbox id="usaturdaycheck" v-model="storeSalesTemplateUpdate.saturday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Sonntag" label-for="usundaycheck">
                     <b-form-checkbox id="usundaycheck" v-model="storeSalesTemplateUpdate.sunday">
                    </b-form-checkbox>
                </b-form-group>

                 <b-form-group label-text-align="left" label-cols="4" label-cols-lg="2" label="Beschreibung" label-for="ust9">
                    <b-form-input id="ust9" v-model="storeSalesTemplate.description" type="text"></b-form-input>
                </b-form-group>
            </div>
            
            <b-row v-if="error">
                Fehler beim Update des Muster Umsatzes.
            </b-row>
        </b-container>
    </b-modal>
    
    <b-modal ref="modal-deletestoresalestemplategroup"  no-close-on-backdrop no-close-on-esc centered title="Umsatz Vorlage löschen" @cancel="hideModal('modal-deletestoresalestemplategroup')" @ok="deleteStoreSalesTemplateGroup" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die Umsatz Vorlage löschen wollen?</p>
            </b-row>
            <b-row v-if="error" class="my-1">
                Fehler beim Löschen der Umsatz Vorlage.
            </b-row>
        </b-container>
    </b-modal>

     <b-modal ref="modal-deletestoresalestemplate"  no-close-on-backdrop no-close-on-esc centered title="Muster Umsatz löschen" @cancel="hideModal('modal-deletestoresalestemplate')" @ok="deleteStoreSalesTemplate" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie den Muster Umsatz löschen wollen?</p>
            </b-row>
            <b-row v-if="error" class="my-1">
                Fehler beim Löschen des Muster Umsatzes.
            </b-row>
        </b-container>
    </b-modal>

  </div>

</template>

<script>
export default {
  name: 'storesalestemplateoverview',
  data () {
    return {

     
      storeSalesTemplateGroupMap: {},
      storeSalesTemplateMap: {},
      storeSalesTemplateGroups: [],
      storeSalesTemplates: [],
      
      storeSalesTemplateGroupFields: [{key:"name", label:"Name", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true},  {key:"actions", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: false}],
      storeSalesTemplateFields: [{key:"from", label:"Von", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true},{key:"to", label:"Bis", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true},
                           {key:"amount", label:"Betrag", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key:"currency", label:"Währung", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key:"weekDays", label:"Wochentage", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: false},{key:"actions", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: false}],
      
      storeSalesTemplateGroup: {
          name: "", 
          description: "",
      },
      storeSalesTemplate: {
         
          from: null,
          to: null,
          amount: 0,
          currency: "EUR",
          monday: false,
          tuesday: false,
          wednesday:false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
          itemCount: 0,
          guestCount: 0,
          planned: true,
          description: ""
          
      },
      
      storeSalesTemplateGroupUpdate: {
          name: "",
          description: "",
      },
      storeSalesTemplateUpdate: {
          updateStoreSales: false,
          from: null,
          to: null,
          amount: 0,
          currency: "EUR",
          monday: false,
          tuesday: false,
          wednesday:false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
          itemCount: 0,
          guestCount: 0,
          planned: true,
          description: ""
          
      },
      storeSalesTemplateGroupId:"",
      storeSalesTemplateId:"",
      error: false,
      
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
         this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function(){
        let view = this;
        
        view.loadStoreSalesTemplateGroups()
        .then(response => {
            view.updateStoreSalesTemplateGroups(response.data);     
        }).catch(function (error) {
            console.log(error)
        })

    },
    createStoreSalesTemplateGroup: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/salestemplategroup';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/salestemplategroup');

        let payload = {
          storeId: this.$store.state.storeId,
          name: this.storeSalesTemplateGroup.name,
          description: this.storeSalesTemplateGroup.description,
        }
       
        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            let storeSalesTemplateGroupItem = {
                id: response.data.data.id,
                name: response.data.data.name,
                description: response.data.data.description
            }
            
            view.storeSalesTemplateGroupMap[response.data.data.id] = response.data.data;
            view.storeSalesTemplateGroups.push(storeSalesTemplateGroupItem);
            
            view.hideModal('modal-createstoresalestemplategroup');
            view.openStoreSalesTemplateGroupViewModal(storeSalesTemplateGroupItem.id);
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    createStoreSalesTemplate: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/salestemplate';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/salestemplate');

        let payload = {
          groupId: this.storeSalesTemplateGroupId,
          from: this.$helpers.convertDateTimeString(null,this.storeSalesTemplate.from),
          to: this.$helpers.convertDateTimeString(null,this.storeSalesTemplate.to),
          amount: Math.floor(this.storeSalesTemplate.amount*100),
          currency: this.storeSalesTemplate.currency,
          itemCount: this.storeSalesTemplate.itemCount,
          guestCount: this.storeSalesTemplate.guestCount,
          description: this.storeSalesTemplate.description,
          planned: this.storeSalesTemplate.planned,
          weekDays: [],
        }
        if(this.storeSalesTemplate.monday){
            payload.weekDays.push(1);
        }
        if(this.storeSalesTemplate.tuesday){
            payload.weekDays.push(2);
        }
        if(this.storeSalesTemplate.wednesday){
            payload.weekDays.push(3);
        }
        if(this.storeSalesTemplate.thursday){
            payload.weekDays.push(4);
        }
        if(this.storeSalesTemplate.friday){
            payload.weekDays.push(5);
        }
        if(this.storeSalesTemplate.saturday){
            payload.weekDays.push(6);
        }
        if(this.storeSalesTemplate.sunday){
            payload.weekDays.push(7);
        }
       
        

        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            
            let storeSalesTemplateItem = {
                id: response.data.data.id,
                from: response.data.data.from,
                to: response.data.data.to,
                amount: response.data.data.amount,
                currency: response.data.data.currency,
                weekDays: response.data.data.weekDays
            }
            
            
            view.storeSalesTemplateMap[response.data.data.id] = response.data.data;
            view.storeSalesTemplates.push(storeSalesTemplateItem); 
            
            view.hideModal('modal-createstoresalestemplate');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    updateStoreSalesTemplateGroup: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/salestemplategroup';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/salestemplategroup');

        let payload = {
          storeId: this.$store.state.storeId,
          id: this.storeSalesTemplateGroupId,
          name: this.storeSalesTemplateGroupUpdate.name,
          updateFields: ['name']
        }

        if(this.storeSalesTemplateGroup.description != this.storeSalesTemplateGroupUpdate.description){
            payload.description = this.storeSalesTemplateGroupUpdate.description;
            payload.updateFields.push('description');
        }
        
        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.storeSalesTemplateGroupMap[view.storeSalesTemplateGroupId].name = view.storeSalesTemplateGroupUpdate.name;
        
            const index = view.storeSalesTemplateGroups.findIndex(storeSalesTemplateGroup => storeSalesTemplateGroup.id === view.storeSalesTemplateGroupId)
           
            view.storeSalesTemplateGroups[index].name = view.storeSalesTemplateGroupUpdate.name;
           

            view.hideModal('modal-editstoresalestemplategroup');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    updateStoreSalesTemplate: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/salestemplate';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/salestemplate');

        let payload = {
          storeId: this.$store.state.storeId,
          id: this.storeSalesTemplateId,
          updateFields: ['weekDays', 'from', 'to'],
          updateStoreSales: this.storeSalesTemplateUpdate.updateStoreSales,
          from: this.$helpers.convertDateTimeString(null,this.storeSalesTemplateUpdate.from),
          to: this.$helpers.convertDateTimeString(null,this.storeSalesTemplateUpdate.to),
          weekDays: []
        }
       
        if(this.storeSalesTemplate.amount != this.storeSalesTemplateUpdate.amount){
            payload.amount = Math.floor(this.storeSalesTemplateUpdate.amount*100);
            payload.updateFields.push("amount");
        }

        if(this.storeSalesTemplate.currency != this.storeSalesTemplateUpdate.currency){
            payload.currency = this.storeSalesTemplateUpdate.currency;
            payload.updateFields.push("currency");
        }

        if(this.storeSalesTemplate.itemCount != this.storeSalesTemplateUpdate.itemCount){
            payload.itemCount = this.storeSalesTemplateUpdate.itemCount;
            payload.updateFields.push("itemCount");
        }

        if(this.storeSalesTemplate.guestCount != this.storeSalesTemplateUpdate.guestCount){
            payload.guestCount = this.storeSalesTemplateUpdate.guestCount;
            payload.updateFields.push("guestCount");
        }

        if(this.storeSalesTemplateUpdate.monday){
            payload.weekDays.push(1);
        }
        if(this.storeSalesTemplateUpdate.tuesday){
            payload.weekDays.push(2);
        }
        if(this.storeSalesTemplateUpdate.wednesday){
            payload.weekDays.push(3);
        }
        if(this.storeSalesTemplateUpdate.thursday){
            payload.weekDays.push(4);
        }
        if(this.storeSalesTemplateUpdate.friday){
            payload.weekDays.push(5);
        }
        if(this.storeSalesTemplateUpdate.saturday){
            payload.weekDays.push(6);
        }
        if(this.storeSalesTemplateUpdate.sunday){
            payload.weekDays.push(7);
        }
        
        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.storeSalesTemplateMap[view.storeSalesTemplateId].from = view.storeSalesTemplateUpdate.from;
            view.storeSalesTemplateMap[view.storeSalesTemplateId].to = view.storeSalesTemplateUpdate.to;
            view.storeSalesTemplateMap[view.storeSalesTemplateId].amount = Math.floor(view.storeSalesTemplateUpdate.amount*100);
            view.storeSalesTemplateMap[view.storeSalesTemplateId].currency = view.storeSalesTemplateUpdate.currency;
            view.storeSalesTemplateMap[view.storeSalesTemplateId].description = view.storeSalesTemplateUpdate.description;
            view.storeSalesTemplateMap[view.storeSalesTemplateId].weekDays = payload.weekDays;

            const index = view.storeSalesTemplates.findIndex(storeSalesTemplate => storeSalesTemplate.id === view.storeSalesTemplateId) 
           
            view.storeSalesTemplates[index].from = view.storeSalesTemplateUpdate.from;
            view.storeSalesTemplates[index].to = view.storeSalesTemplateUpdate.to;
            view.storeSalesTemplates[index].amount = Math.floor(view.storeSalesTemplateUpdate.amount*100);
            view.storeSalesTemplates[index].currency = view.storeSalesTemplateUpdate.currency;
            view.storeSalesTemplates[index].weekDays = payload.weekDays;

            view.hideModal('modal-editstoresalestemplate');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    deleteStoreSalesTemplateGroup: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/salestemplategroup';
        
        url = this.$helpers.appendParam("id", this.storeSalesTemplateGroupId, url, '/api/sec/salestemplategroup');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/salestemplategroup');
       
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = this.storeSalesTemplateGroups.findIndex(storeSalesTemplateGroup => storeSalesTemplateGroup.id === view.storeSalesTemplateGroupId) 
            if (~index) {
                view.storeSalesTemplateGroups.splice(index, 1);
            }
            view.deleteStoreSalesTemplateGroupFromMap(view.storeSalesTemplateGroupId);   
            view.hideModal('modal-deletestoresalestemplategroup');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    deleteStoreSalesTemplate: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/salestemplate';
        
        url = this.$helpers.appendParam("id", this.storeSalesTemplateId, url, '/api/sec/salestemplate');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/salestemplate');
       
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = this.storeSalesTemplates.findIndex(storeSalesTemplate => storeSalesTemplate.id === view.storeSalesTemplateId) 
            if (~index) {
                view.storeSalesTemplates.splice(index, 1);
            }
            view.deleteStoreSalesTemplateFromMap(view.storeSalesTemplateId);   
            view.hideModal('modal-deletestoresalestemplate');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    openStoreSalesTemplateGroupViewModal: function(id){
        
        this.storeSalesTemplateGroupId = id;
        
        let view = this;
        this.loadStoreSalesTemplates()
        .then(response => {
            view.updateStoreSalesTemplates(response.data);
            view.showModal('modal-viewstoresalestemplategroup');     
        }).catch(function (error) {
            console.log(error)
        })
    },
    openStoreSalesTemplateViewModal: function(id){
        
        this.storeSalesTemplateId = id;
        this.showModal('modal-viewstoresalestemplate'); 

    },
    openStoreSalesTemplateGroupEditModal: function(id){
        
        this.storeSalesTemplateGroupId = id;
        let group = this.storeSalesTemplateGroupMap[this.storeSalesTemplateGroupId];
        
        if(!this.$helpers.isBlank(group.name)){
            this.storeSalesTemplateGroup.name = group.name;
            this.storeSalesTemplateGroupUpdate.name = group.name;
        }
        if(!this.$helpers.isBlank(group.description)){
            this.storeSalesTemplateGroup.description = group.description;
            this.storeSalesTemplateGroupUpdate.description = group.description;
        }
        
        this.showModal('modal-editstoresalestemplategroup');
    },
    openStoreSalesTemplateEditModal: function(id){
        
        this.storeSalesTemplateId = id;
        let template = this.storeSalesTemplateMap[this.storeSalesTemplateId];

        this.storeSalesTemplateUpdate.updateStoreSales = false;
       
       
        this.storeSalesTemplate.from = this.$helpers.extractTimeString(template.from);
        this.storeSalesTemplateUpdate.from = this.$helpers.extractTimeString(template.from);
        
        this.storeSalesTemplate.to = this.$helpers.extractTimeString(template.to);
        this.storeSalesTemplateUpdate.to = this.$helpers.extractTimeString(template.to);
        
        this.storeSalesTemplate.itemCount = template.itemCount;
        this.storeSalesTemplateUpdate.itemCount = template.itemCount;

        this.storeSalesTemplate.guestCount = template.guestCount;
        this.storeSalesTemplateUpdate.guestCount = template.guestCount;

        this.storeSalesTemplate.amount = template.amount/100;
        this.storeSalesTemplateUpdate.amount = template.amount/100;

        this.storeSalesTemplate.currency = template.currency;
        this.storeSalesTemplateUpdate.currency = template.currency;

        this.storeSalesTemplate.description = template.description;
        this.storeSalesTemplateUpdate.description = template.description;

        if(template.weekDays.includes(1)){
            this.storeSalesTemplate.monday = true;
            this.storeSalesTemplateUpdate.monday = true;
        }
        if(template.weekDays.includes(2)){
            this.storeSalesTemplate.tuesday = true;
            this.storeSalesTemplateUpdate.tuesday = true;
        }
        if(template.weekDays.includes(3)){
            this.storeSalesTemplate.wednesday = true;
            this.storeSalesTemplateUpdate.wednesday = true;
        }
        if(template.weekDays.includes(4)){
            this.storeSalesTemplate.thursday = true;
            this.storeSalesTemplateUpdate.thursday = true;
        }
        if(template.weekDays.includes(5)){
            this.storeSalesTemplate.friday = true;
            this.storeSalesTemplateUpdate.friday = true;
        }
        if(template.weekDays.includes(6)){
            this.storeSalesTemplate.saturday = true;
            this.storeSalesTemplateUpdate.saturday = true;
        }
        if(template.weekDays.includes(7)){
            this.storeSalesTemplate.sunday = true;
            this.storeSalesTemplateUpdate.sunday = true;
        }

        
        this.showModal('modal-editstoresalestemplate');
    },
    openStoreSalesTemplateGroupDeleteModal: function(id){

        this.storeSalesTemplateGroupId = id;
        this.showModal('modal-deletestoresalestemplategroup');
    },
    openStoreSalesTemplateDeleteModal: function(id){
        this.storeSalesTemplateId = id;
        this.showModal('modal-deletestoresalestemplate');
    },
    loadStoreSalesTemplateGroups : function() {
     
      let url = '/api/sec/salestemplategroup';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/salestemplategroup');
      

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
			
    },
    loadStoreSalesTemplates : function() {
      
      let url = '/api/sec/salestemplate';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/salestemplate');
      url = this.$helpers.appendParam("groupId", this.storeSalesTemplateGroupId, url, '/api/sec/salestemplate')

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    updateStoreSalesTemplateGroups: function(data) {
        let overviewA = [];
        let map = {};
        var i;
        for (i = 0; i < data.length; i++) {
            map[data[i].id] = data[i]; 
            let storeSalesTemplateGroupItem = {
                id: data[i].id,
                name: data[i].name, 
            }
            
            overviewA.push(storeSalesTemplateGroupItem);
        }
        this.storeSalesTemplateGroupMap = map;
        this.storeSalesTemplateGroups = overviewA;
    },
    updateStoreSalesTemplates: function(data) {
        let overviewA = [];
        let map = {};
        var i;
        for (i = 0; i < data.length; i++) {
            map[data[i].id] = data[i]; 
            let storeSalesTemplateItem = {
                id: data[i].id,
                from: this.$helpers.extractTimeString(data[i].from),
                to: this.$helpers.extractTimeString(data[i].to),
                amount: data[i].amount,
                currency: data[i].currency,
                weekDays: data[i].weekDays,
                itemCount: data[i].itemCount
            }
            overviewA.push(storeSalesTemplateItem);
        }
        this.storeSalesTemplateMap = map;
        this.storeSalesTemplates = overviewA;
    },
    
    deleteStoreSalesTemplateGroupFromMap(id){
       
        for(let p in this.storeSalesTemplateMap){
            if(this.storeSalesTemplateMap[p].groupId === id){
                this.deleteStoreSalesTemplateFromMap(p);
            }
        }
        
        delete this.storeSalesTemplateGroupMap[id];
    },
    deleteStoreSalesTemplateFromMap(id){
        
        delete this.storeSalesTemplateMap[id]
    },
    hideModal (ref) {
        this.error = false;
        this.resetStoreSalesTemplateGroupValues();
        this.resetStoreSalesTemplateValues();
        this.$refs[ref].hide();
    },
    resetStoreSalesTemplateGroupValues() {
        this.storeSalesTemplateGroup = {
          name: "",
          description: "", 
        };
        this.storeSalesTemplateGroupUpdate ={
            name: "", 
            description: "",
        };

    },
    resetStoreSalesTemplateValues() {
        this.storeSalesTemplate ={
         
          from: null,
          to: null,
          amount: 0,
          currency: "EUR",
          monday: false,
          tuesday: false,
          wednesday:false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
          itemCount: 0,
          guestCount: 0,
          planned: true,
          description: ""
          
      };
     
      this.storeSalesTemplateUpdate = {
          updateStoreSales: false,
          from: null,
          to: null,
          amount: 0,
          currency: "EUR",
          monday: false,
          tuesday: false,
          wednesday:false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
          itemCount: 0,
          guestCount: 0,
          planned: true,
          description: ""
          
      };
    },
    
    showModal(ref) {
        this.$refs[ref].show()
    }
  },
  components: {
  },
  computed: {
   
  },
  watch: { 
   

    }

}
</script>

<!-- Add "scoped" attrispotte to limit CSS to this component only -->
<style scoped>

</style>
